import { FC, ReactNode, useEffect } from 'react'
import dynamic from 'next/dynamic'
import clsx from 'clsx'

const PortalWrap = dynamic(() => import('containers/portal-wrap/portal-wrap'), { ssr: false })
import useNavbarHeight from 'store/navbar/useNavbarHeight'

import { enableDocumentScroll, disableDocumentScroll } from 'utils/handlerDocumentScroll'

import styles from './overlay.module.scss'

interface IOverlay {
  children: ReactNode
  top?: string
  banScroll?: boolean
  withAnimation?: boolean
}

const Overlay: FC<IOverlay> = ({ children, top, banScroll, withAnimation }: IOverlay) => {
  const { navbarHeight } = useNavbarHeight()

  useEffect(() => {
    if (banScroll) {
      disableDocumentScroll()
    }

    return () => {
      if (banScroll) {
        enableDocumentScroll()
      }
    }
  }, [banScroll])

  return (
    <PortalWrap>
      <div
        className={clsx(styles.menuLayout, { [styles.animation]: withAnimation })}
        style={{ top: top || `${navbarHeight}px` }}
      >
        {children}
      </div>
    </PortalWrap>
  )
}

export default Overlay
